module.exports = __webpack_public_path__ + "static/owner-97beb65c9cb02908b86736a2c9d2eb3a.jpeg";